'use client';

import type { PropsWithChildren } from 'react';

import { withGuard } from '@/helpers/hocs';
import { useCMSConfig } from '@/modules/common';

function MobileAppPage({ children }: PropsWithChildren) {
  return children;
}

export default withGuard(MobileAppPage, {
  checkIsHiddenPage: () => {
    const { mobileAppCMS } = useCMSConfig();

    return !mobileAppCMS;
  },
  redirectUrl: '/',
  userGroups: [],
  showIfNotAuthenticated: true,
});
